export interface UndoToastProps {
  label: string;
  onUndo: () => void;
}

export function UndoToast({ label, onUndo }: UndoToastProps) {
  return (
    <div className="relative flex w-full items-center gap-3 overflow-hidden rounded-xl border border-line-2 bg-card px-3 py-2.5 shadow-card">
      <div className="flex-1 text-body text-t1">{label}</div>
      <button
        type="button"
        onClick={onUndo}
        className="pressable rounded-md bg-t1 px-2.5 py-1 text-caption text-canvas focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-card pointer-coarse:min-h-[44px]"
      >
        Undo
      </button>
      <div className="undo-progress absolute bottom-0 left-0 h-0.5 bg-brand" aria-hidden />
    </div>
  );
}
